export default {
	roboAdvisoryAnalysisOverviewTitle: 'Přehled analýz REDy',
	analysisType: 'Druh analýzy',
	analysisState: 'Stav analýzy',
	client: 'Klient',
	personIn: 'Rodné číslo',
	businessIn: 'IČO',
	type: 'Typ',
	product: 'Produkt',
	municipality: 'Obec',
	zipCode: 'PSČ',
	dateCreated: 'Datum vytvoření',
	inProcess: 'Rozpracované',
	finished: 'Dokončené',
	finishedWithContract: 'Dokončené se smlouvou',
	finishedWithoutSignature: 'Dokončené bez podpisu',
	roboAdvisoryTableRecords2YearsOldOnly: 'Je možné vyhledat pouze analýzy, které nejsou starší než 2 roky.',
	handOverRAAnalysis: 'Předat jinému OZ',
	roboAdvisoryHeader: 'ANALÝZY REDy PODŘÍZENÉHO UŽIVATELE',
	handOverModalTitle: 'Předání produktových analýz',
	handOverModalButton: 'Předat',
	handOverModalNoSubordinate: 'Vyberte podřízeného uživatele.',
	raSelectAmountLimitForHandover: 'Můžete předat najednou maximálně 20 analýz.',

	surname: 'Příjmení',
	firstName: 'Jméno',
	businessName: 'Název',
	productCode: 'Produkt',
	types: 'Druh analýzy',
	states: 'Stav analýzy',
	createdDateFrom: 'Datum vytvoření od',
	createdDateTo: 'Datum vytvoření do',
	handoverTo: 'Podřízení uživatelé',
};
